export default __webpack_public_path__ + "static/consulting_conference_qr_code-ad65e5b7038dadec332e0f785f1c58dc.png";